var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"medication"},[_c('span',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.attributes.name)+" ")]),_c('span',{staticClass:"count"},[_vm._v(" "+_vm._s(this.attributes.dose)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }